import React from 'react';
import styles from '../../styles/PageStyles';
import theme from '../../styles/PageTheme';
import SendIcon from '@mui/icons-material/Send';
import CheckIcon from '@mui/icons-material/Check';
/**
 * Takes in boolean parameters to render the correct verbiage for the send
 * estimates button. The states reflect whether or not the estimate has been sent.
 * @param {boolean} estimateSent
 * @param {boolean} sendEstimatesLoading
 * @returns {Object}
 */
const sendEstimateButtonLabel = (estimateSent, sendEstimatesLoading) => {
    const classes = styles(theme);

    return (
        <React.Fragment>
            {estimateSent ? (
                <CheckIcon className={'.tds-button--secondary-one'} sx={{ mr: 0.5 }} />
            ) : (
                !sendEstimatesLoading && (
                    <SendIcon className={'.tds-button--secondary-one'} sx={{ mr: 0.5 }} />
                )
            )}
            <span style={sendEstimatesLoading ? classes.loadingButton : classes.printEstimateText}>
                {estimateSent ? 'Estimate(s) Sent!' : 'Send estimate(s)'}
            </span>
        </React.Fragment>
    );
};

export default sendEstimateButtonLabel;
